
export default {
  props: {
    tabs: { type: Array, required: true },
    value: { type: [String, Number, Symbol], required: true }
  }
};
